import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "CategoriaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "CategoriaPage",
            ss: ss,
            ajax: {
                "url": ss.indexCategoria(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Categoria', name: 'Categoria', title: 'Categoría' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            categorias: [],
            categoria: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newCategoria() {
            this.categoria = {};
            this.$refs['frm-categoria'].show();
        },
        showCategoria(id) {
            this.isLoading=true;
            this.ss.showCategoria(id).then(
                (result) => {
                    let response = result.data;
                    this.categoria = response.data;
                    this.$refs['view-categoria'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editCategoria() {
            this.$refs['frm-categoria'].show();
            this.$refs['view-categoria'].hide();
        },
        cancelCategoria() {
            if (this.categoria.id) {
                this.$refs['view-categoria'].show();
            }
            this.$refs['frm-categoria'].hide();
        },
        saveCategoria() {
            this.ss.storeCategoria(this.categoria).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-categoria'].hide();
                    this.$refs['datatable-categoria'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteCategoria() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyCategoria(this.categoria)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-categoria'].hide();
                                this.$refs['datatable-categoria'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Categoria').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showCategoria(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
